import React from 'react';
import PropTypes from 'prop-types';
import QuestIndicator from '../assets/QuestIndicator.svg';
import './QuestProgressBar.css';

function QuestProgressBar({
  completion,
  progressText,
  ratio = 0,
  isComplete = false,
  icon = null,
  isMissionTracker = false,
  missionStatuses
}) {
  if (isMissionTracker) {
    const completedTasks = missionStatuses.filter(
      mission => mission.progress >= mission.goal
    ).length;
    const trackerCompletion =
      Math.floor((completedTasks / missionStatuses.length) * 100) + '%';
    return (
      <div className="quest-progress-bar">
        <div className="progress-text">
          {completedTasks} / {missionStatuses.length} Tasks Complete
        </div>
        <div className="current-progress" style={{ width: trackerCompletion }}>
          <div
            className={`progress-bar-fill ${
              completedTasks === missionStatuses.length ? 'complete' : ''
            }`}
          />
        </div>
      </div>
    );
  }

  const width =
    completion !== undefined
      ? completion
      : Math.floor(Math.max(0.0, Math.min(ratio, 1.0)) * 100.0) + '%';

  return (
    <div className="quest-progress-bar">
      {progressText && <div className="progress-text">{progressText}</div>}
      <div className="current-progress" style={{ width }}>
        <div className={`progress-bar-fill ${isComplete ? 'complete' : ''}`} />
        {!progressText && (
          <img className="progress-bar-indicator" src={QuestIndicator} alt="" />
        )}
        {!!icon && (
          <img className="progress-bar-indicator-icon" src={icon} alt="" />
        )}
      </div>
    </div>
  );
}

QuestProgressBar.propTypes = {
  completion: PropTypes.string,
  progressText: PropTypes.string,
  ratio: PropTypes.number,
  isComplete: PropTypes.bool,
  icon: PropTypes.string,
  isMissionTracker: PropTypes.bool,
  missionStatuses: PropTypes.arrayOf(PropTypes.object)
};

export default QuestProgressBar;
